var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewbankIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58317 0.833374L1.6665 5.00004V6.66671H17.4998V5.00004L9.58317 0.833374ZM13.3332 8.33337V14.1667H15.8332V8.33337H13.3332ZM1.6665 18.3334H17.4998V15.8334H1.6665V18.3334ZM8.33317 8.33337V14.1667H10.8332V8.33337H8.33317ZM3.33317 8.33337V14.1667H5.83317V8.33337H3.33317Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewbankIcon);
export default __webpack_public_path__ + "static/media/viewbank-icon.ed48e7c0bed47f46746242cd87c132f9.svg";
export { ForwardRef as ReactComponent };